import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";

export default function Navbar({ color, imageObject, navItems = [] }) {
  const [scrolling, setScrolling] = useState(false);
  const [scrolledHalfway, setScrolledHalfway] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const hide = window.innerHeight * 0.08;
      const half = window.innerHeight * 0.6;
      const halfway = window.innerHeight * 0.5;

      if (scrollY > hide) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
      if (scrollY > half) {
        setScrolling(false);
        document.body.classList.add("scrolled-halfway");
      } else {
        document.body.classList.remove("scrolled-halfway");
      }
      if (scrollY > halfway) {
        setScrolledHalfway(true);
      } else {
        setScrolledHalfway(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        data-navbar-fixed
        className={`${styles.navbar} ${scrolledHalfway ? styles.scrolledhalfway : ""} ${
          scrolling ? styles.hidden : ""
        }`}
        style={{ "--nav-primary": color.primary }}
      >
        <div className={styles.header}>
          <nav className={styles.navRoot} aria-label="Main" dir="ltr">
            <ul className={styles.topNavList}>
              {navItems.map((item) => (
                <li key={item.to + (item.end ? "-index" : "")}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) =>
                      `${styles.topNavLink} ${isActive ? styles.topNavLinkActive : ""}`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div id="site-navbar-logo-band" className={styles.logoBand}>
        <div className={styles.mobile}>
          <div
            style={{
              width: "100%",
              padding: "15px 0 0 0",
              background: color.primary,
            }}
          >
            <Link to="/">
              <img
                src={imageObject.image9}
                alt="TargeTube"
                style={{ width: "70%" }}
              />
            </Link>
          </div>
        </div>
        <div className={styles.desktop}>
          <div
            style={{
              width: "100%",
              background: color.primary,
            }}
          >
            <Link to="/">
              <img
                src={imageObject.image9}
                alt="TargeTube"
                style={{ width: "70%" }}
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
